import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { getDocs, query, where, collection, orderBy, limit } from "firebase/firestore";
import { db } from "../firebase";
import { signInWithGoogle, googleLogout, checkUserAuth } from '../firebase';
import Cookies from 'js-cookie';
import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Loadingimg from '../components/loadingimg';

import Photosicon from '../assets/photos_icon.png';
import { VscVmConnect, VscLock, VscCloudDownload, VscEdit, VscGistSecret, VscCallIncoming, VscLocation, VscBriefcase, VscCalendar, VscMail } from "react-icons/vsc";
import './account.css';

import { IoIosLink, IoIosShareAlt } from "react-icons/io";
import Navbar from '../master_root/Navbar';
import Footer from '../master_root/footer';
import Header from '../master_root/header';
import axios from 'axios';
import ShareButton from '../components/ShareButton';  
export default function Account() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [guid, setGuid] = useState("");
  const [ProfileProgress, setProfileProgress] = useState(10);

  const [UsersData, setUsersData] = useState([]);
  const [skilsdetailsData, setskilsdetailsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [usersdetailsdata, setUsersdetailsdata] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [islogoutLoading, setislogoutLoading] = useState(false);
  const [Usersloginlist, setUsersloginlist] = useState([]);
  const popupRef = useRef(null);
  const [loginisOpen, loginsetIsOpen] = useState(false);
  const [Selected, setSelected] = useState('Profile');
  useEffect(() => {
    const existingUser = Cookies.get("guid");

    if (existingUser != null) {
      setGuid(existingUser); // Still sets it in state if you need it elsewhere
      loginsetIsOpen(true);
      fetchdetails();
      fetch_skils_details();
      const fetchusers = async () => {
        try {
          const userQuery = query(
            collection(db, "users"),
            where("guid", "==", existingUser) // use existingUser directly
          );
          const userSnapshot = await getDocs(userQuery);

          const dataList = await Promise.all(
            userSnapshot.docs.map(async (doc) => {
              const usersData = { id: doc.id, ...doc.data() };
              const detailsQuery = query(
                collection(db, "users_details"),
                where("guid", "==", usersData.guid)
              );

              const detailsSnapshot = await getDocs(detailsQuery);
              const detailsData = detailsSnapshot.docs.map((detailsDoc) => ({
                uid: detailsDoc.id,
                ...detailsDoc.data(),
              }))[0] || null;

              return {
                ...usersData,
                DetailsData: detailsData,
              };
            })
          );

          setUsersData(dataList);
        } catch (error) {
          console.error("Error fetching users:", error);
        } finally {
          setIsLoading(false);
        }
      };

      fetchusers();
    } else {
      loginsetIsOpen(false);
      navigate('/');
    }

  }, []);
  const fetchdetails = async () => {
    setIsLoading(true);
    try {
      const userQuery = query(
        collection(db, "users_details"),
        where("guid", "==", Cookies.get("guid"))
      );
      const userSnapshot = await getDocs(userQuery);

      const usersData = userSnapshot.docs.map((userDoc) => ({
        uid: userDoc.id,
        ...userDoc.data(),
      }));

      // Calculate progress based on matching entries
      let progress = 0;

      if (usersData.details === "education") {
        progress += 50;
      }
      if (usersData.details === "projects") {
        progress += 30;
      }
      if (usersData.details === "profile_summary") {
        progress += 30;
      }
      if (usersData.details === "resume") {
        progress += 50;
      }
      setProfileProgress(progress + ProfileProgress);
      setUsersdetailsdata(usersData);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetch_skils_details = async () => {

    try {
      const userQuery = query(
        collection(db, "skils_details"),
        where("guid", "==", Cookies.get("guid"))
      );
      const userSnapshot = await getDocs(userQuery);

      const usersData = userSnapshot.docs.map((userDoc) => ({
        uid: userDoc.id,
        ...userDoc.data()
      }));
      let progress = 50;

      setProfileProgress(progress + ProfileProgress);
      //
      setskilsdetailsData(usersData);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleGoogleLogin = async () => {
    const userData = await signInWithGoogle();
    setUser(userData);
    setTimeout(() => window.location.reload(), 2000);
  };

  const handleGoogleLogout = async () => {
    setislogoutLoading(true);
    await googleLogout();
    setUser(null);

    setTimeout(() => {
      navigate('/');
      window.location.reload();
    }, 2000);
  };

  //users_login
  useEffect(() => {
    const fetchUsersLogin = async () => {
      setIsLoading(true); // 🔄 Ensure loading starts
      try {
        const q = query(
          collection(db, "users_login"),
          where("guid", "==", guid),
          orderBy("date_time", "desc"),
          limit(10)
        );
        const querySnapshot = await getDocs(q);
        const usersLoginList = querySnapshot.docs.map(doc => ({
          uid: doc.id,
          ...doc.data()
        }));
        setUsersloginlist(usersLoginList);
      } catch (error) {
        console.error("Error fetching users_login:", error);
      } finally {
        setIsLoading(false); // ✅ Moved to finally for consistency
      }
    };

    fetchUsersLogin();

  }, [guid]);


  const account_details = (details) => {

    navigate('/account-details?id=' + details.replaceAll(" ", "-"), {
      state: { details }
    });
  }
  const [file, setFile] = useState(null);
  const onFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const onFileUpload = async () => {
    if (!file) {
      alert('Please select a file.');
      return;
    }
    const formData = new FormData();
    formData.append('file', file);

    try {
      const apiURL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
      const response = await axios.post(`${apiURL}/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      alert('File uploaded successfully');
      console.log(response.data);
    } catch (error) {
      alert('Error uploading file' + error);
      console.error(error);
    }
  };
    const handleChange = () => {
        navigate('/photo-change?id=photo');
    }

  return (
    <div>
      <Header />
      <div className='app_header_height'></div>
      <Helmet>
        <title>Profile</title>
      </Helmet>
      <div className="container_size">
        <br />
        <div className='tabs-body'>
          <div
            onClick={() => setSelected('Profile')}
            className={`tabsbutton ${Selected === 'Profile' ? 'active' : ''}`}
            title="Profile"
          >
            <span className="tabs-text">Profile</span>
          </div>
        
          <div
            onClick={() => setSelected('History')}
            className={`tabsbutton ${Selected === 'History' ? 'active' : ''}`}
            title="History"
          >
            <span className="tabs-text">History</span>
          </div>
        </div>

      </div>

      {/* profile */}
      {Selected === 'Profile' && (

        <div className="container_roots">
          <br />
          <div className="container_size">
            <div className='post-container'>
              <div className='post_updates profile_div'>
                <a className='pro-lable_health'></a>
                <div className='progress-ring-label' >Profile {ProfileProgress}% Complete</div>
                {isLoading ? (
                  <Lodinging />
                ) : (
                  UsersData.map((user, index) => (
                    <div className="prf-photo" key={index} onClick={handleChange}>
                      <div
                        className="progress-ring"
                        style={{
                          background: `conic-gradient(green 0% ${ProfileProgress}%, transparent ${ProfileProgress}% 100%)`
                        }}>

                        <img
                          className="profile-img"
                          src={user.photoURL}
                          alt="User"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = Photosicon;
                          }}
                        />
                      </div>
                    </div>
                  ))
                )}

                <div className='account-actionbar'>
                  {isLoading ? (
                    <Lodinging /> // Assuming this is your loading component
                  ) : (
                    UsersData.map((user, index) => (
                      <div key={index}>
                        <table className='account-status'>
                          <tr>
                            <td>
                              <div className={`account-status ${user.status ? "active" : "deactive"}`}>
                                Status:<b> {user.status ? "Active" : "Deactive"}</b>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className='account-status'>
                                At: {new Date(user.datetime.seconds * 1000).toLocaleString('en-GB', {
                                  day: 'numeric',
                                  month: 'short',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                }).toUpperCase()}

                              </div>

                            </td>
                          </tr>
                        </table>

                      </div>
                    ))
                  )}
                  <div className="button-ui3 account-btn" onClick={handleGoogleLogout}>
                    {islogoutLoading ? <Loadingimg /> : <VscLock className="icon" />}
                    Logout
                  </div>
                </div>
              </div>

              <div className='post_div profile_div'>
                {isLoading ? (
                  <Lodinging />
                ) : (
                  UsersData.map((user, index) => (
                    <div key={index}>
                      <table className='name-table'>
                        <tbody>
                          <tr>
                            <td><div className='pro-name'>{user.name}</div></td>
                          </tr>
                          <tr>
                            <td>
                              <div className='pro-info'>
                                Profile last updated - {new Date(user.updated_datetime.seconds * 1000).toLocaleDateString('en-GB', {
                                  day: 'numeric',
                                  month: 'short',
                                  year: 'numeric',
                                }).toUpperCase()}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div className='name-table-div'>
                        <table className='name-table-loc'>
                          <tbody>
                            <tr>
                              <td className='pro-icon'><VscLocation className='pro-icon' /></td>
                              <td className='pro-lable'>
                                <div>
                                  {user.address || user.city || user.state || user.country ? (
                                    <>
                                      {user.address && <>{user.address}<br /></>}
                                      {[user.city, user.state, user.country].filter(Boolean).join(", ")}
                                    </>
                                  ) : (
                                    "N/A"
                                  )}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className='pro-icon'><VscBriefcase className='pro-icon' /></td>
                              {(() => {
                                if (user.DetailsData?.title == "work_status") {
                                  return <td className='pro-lable'>{user.DetailsData?.values || "N/A"}</td>;
                                } else {
                                  return <td className='pro-lable_btn'>Add Work Status</td>;
                                }
                              })()}

                            </tr>
                            <tr>
                              <td className='pro-icon'><VscCalendar className='pro-icon' /></td>
                              {(() => {
                                if (user.DetailsData?.title == "work_time_start") {
                                  return <td className='pro-lable'>{user.DetailsData?.values || "N/A"}</td>;
                                } else {
                                  return <td className='pro-lable_btn'>Add Work Status</td>;
                                }
                              })()}
                            </tr>
                          </tbody>
                        </table>

                        <table className='name-table-cont-num'>
                          <tbody>
                            <tr>

                              <td className='pro-icon'><IoIosLink className='pro-icon' /></td>
                              <td className="pro-lable">
                                <a className='slug-link' title='Your profile link' href={user.slug}>{user.slug}</a>
                              </td>

                              <td className='pro-icon'><ShareButton

                                url={'https://editortask.com/' + user.slug}
                              /></td>
                            </tr>
                            <tr>

                              <td className='pro-icon'><VscCallIncoming className='pro-icon' /></td>
                              <td className="pro-lable">
                                <a onClick={() => navigate('/phone-verified')} style={{ cursor: 'pointer' }} >+{user.phone} <b>Get Verified</b></a>
                              </td>
                            </tr>
                            <tr>
                              <td className='pro-icon'><VscMail className='pro-icon' /></td>
                              <td className='pro-lable'>
                                <a onClick={() => navigate('/email-change')} style={{ cursor: 'pointer' }}>{user.email} <b>Get Change</b></a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))
                )}
              </div>

            </div>
            <div className='post-container'>
            <div className='post_div'>
  <br />
  <div className='hd-text'>Account Details</div>

  {/* Education */}
  {usersdetailsdata.some(user => user.details === "education") ? (
    usersdetailsdata
      .filter(user => user.details === "education")
      .map((user, index) => (
        <table className="tr-body" key={`edu-${index}`}>
          <tbody>
            <tr>
              <td className="pro-doc-lable">
                <b>{user.title}</b> : {user.value}, Score: {user.score}, Year: {user.year}
              </td>
              <td className="pro-lable_btn" onClick={() => account_details("education")}>
                Education
              </td>
            </tr>
          </tbody>
        </table>
      ))
  ) : (
    <table className="tr-body">
      <tbody>
        <tr>
          <td className="pro-doc-lable">Education</td>
          <td className="pro-lable_btn" onClick={() => account_details("education")}>Add</td>
        </tr>
      </tbody>
    </table>
  )}

  {/* Key Skills */}
  {skilsdetailsData.length > 0 ? (
    skilsdetailsData.map((user, index) => (
      <table className="tr-body" key={`skill-${index}`}>
        <tbody>
          <tr>
            <td className="pro-doc-lable"><b>{user.jobCategories}</b> : {user.description}</td>
            <td className="pro-lable_btn" onClick={() => account_details("key_skills")}>Skills</td>
          </tr>
        </tbody>
      </table>
    ))
  ) : (
    <table className="tr-body">
      <tbody>
        <tr>
          <td className="pro-doc-lable">Key Skills</td>
          <td className="pro-lable_btn" onClick={() => account_details("key_skills")}>Add</td>
        </tr>
      </tbody>
    </table>
  )}

  {/* Projects */}
  {usersdetailsdata.some(user => user.details === "projects") ? (
    usersdetailsdata
      .filter(user => user.details === "projects")
      .map((user, index) => (
        <table className="tr-body" key={`proj-${index}`}>
          <tbody>
            <tr>
              <td className="pro-doc-lable"><b>{user.title}</b> : {user.value}</td>
              <td className="pro-lable_btn" onClick={() => account_details("projects")}>Projects</td>
            </tr>
          </tbody>
        </table>
      ))
  ) : (
    <table className="tr-body">
      <tbody>
        <tr>
          <td className="pro-doc-lable">Projects</td>
          <td className="pro-lable_btn" onClick={() => account_details("projects")}>Add</td>
        </tr>
      </tbody>
    </table>
  )}

  {/* Profile Summary */}
  {usersdetailsdata.some(user => user.details === "profile_summary") ? (
    usersdetailsdata
      .filter(user => user.details === "profile_summary")
      .map((user, index) => (
        <table className="tr-body" key={`summary-${index}`}>
          <tbody>
            <tr>
              <td className="pro-doc-lable"><b>{user.title}</b> : {user.value}</td>
              <td className="pro-lable_btn" onClick={() => account_details("profile_summary")}>Summary</td>
            </tr>
          </tbody>
        </table>
      ))
  ) : (
    <table className="tr-body">
      <tbody>
        <tr>
          <td className="pro-doc-lable">Profile Summary</td>
          <td className="pro-lable_btn" onClick={() => account_details("profile_summary")}>Add</td>
        </tr>
      </tbody>
    </table>
  )}

  {/* Resume */}
  {usersdetailsdata.some(user => user.details === "resume") ? (
    usersdetailsdata
      .filter(user => user.details === "resume")
      .map((user, index) => (
        <table className="tr-body" key={`resume-${index}`}>
          <tbody>
            <tr>
              <td className="pro-doc-lable"><b>{user.title}</b> : {user.value}</td>
              <td className="pro-lable_btn" onClick={() => account_details("resume")}>Resume</td>
            </tr>
          </tbody>
        </table>
      ))
  ) : (
    <table className="tr-body">
      <tbody>
        <tr>
          <td className="pro-doc-lable">Resume</td>
          <td className="pro-lable_btn" onClick={() => account_details("resume")}>Add</td>
        </tr>
      </tbody>
    </table>
  )}
</div>


            </div>
          </div>
        </div>
      )}
    
      {/* History */}
      {Selected === 'History' && (
        <div className="container_roots">
          <br />
          <div className="container_size">
            <div>
              <div className='hd-text'>Login last 10 records</div>
            </div>
            <div >
              {isLoading ? (
                <Lodinging />
              ) : (
                <div >
                  {Usersloginlist.map((loginlist, index) => (
                    <table className="tr-body" key={index}>
                      <tbody>
                        <tr>
                          <td className="pro-doc-lable">             {loginlist.date_time ? (
                            loginlist.date_time.toDate().toLocaleString('en-GB', {
                              day: 'numeric',
                              month: 'short',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: true
                            }).toUpperCase()
                          ) : (
                            "No Date"
                          )}</td>

                          <td className="pro-lable_btn"  >{loginlist.uid}</td>
                        </tr>
                      </tbody>
                    </table>


                    // <table className='login-table  profile_div'>
                    // <tbody>

                    // <tr className="loginlist" title={loginlist.uid} key={index}>
                    //   <td>{loginlist.uid.length > 10 ? loginlist.uid.substring(10) : loginlist.uid}</td>

                    //   <td>
                    //     {loginlist.date_time ? (
                    //       loginlist.date_time.toDate().toLocaleString('en-GB', {
                    //         day: 'numeric',
                    //         month: 'short',
                    //         year: 'numeric',
                    //         hour: '2-digit',
                    //         minute: '2-digit',
                    //         hour12: true
                    //       }).toUpperCase()
                    //     ) : (
                    //       "No Date"
                    //     )}
                    //   </td>

                    // </tr>
                    //    </tbody>
                    //    </table>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <Navbar/>
      <Footer/>
    </div>

  );
}
